const initialState = {
  billers: [],
};

const getters = {
  billers: state => state.billers,
};

const mutations = {
  SET_BILLERS(state, billers) {
    state.billers = [...billers];
  },
};

const actions = {
  async fetch({ commit, state, rootState, rootGetters }) {
    if (state.billers.length === 0) {
      let billers = [];
      try {
        const walletToggle = rootGetters['mitra-wallet/governmentRevenue'];
        if (walletToggle) {
          const {
            customer_products: customerProducts,
          } = await rootState.apiService.getInfoBuka20();
          billers = Object.values(
            // eslint-disable-next-line unicorn/no-array-reduce
            customerProducts.reduce((arr, cp) => {
              if (cp.status === 'available') {
                const category = cp.product_metadata_list.find(pm => pm.name === 'category');
                const categoryName = cp.product_metadata_list.find(
                  pm => pm.name === 'category_name'
                );
                const categorLogoUrl = cp.product_metadata_list.find(
                  pm => pm.name === 'category_logo_url'
                );
                if (category?.value) {
                  if (arr[category?.value]) {
                    arr[category?.value].options = [
                      ...arr[category?.value].options,
                      {
                        name: cp.name,
                        value: cp.code,
                        logoUrl: cp.vendor.logo_url,
                        parentName: category?.value,
                        parentValue: category?.value,
                        partnerId: cp.partner_id,
                      },
                    ];
                  } else {
                    arr[category?.value] = {
                      name: categoryName?.value,
                      value: category?.value,
                      logoUrl: categorLogoUrl?.value,
                      options: [
                        {
                          name: cp.name,
                          value: cp.code,
                          logoUrl: categorLogoUrl?.value,
                          parentName: categoryName?.value,
                          parentValue: category?.value,
                          partnerId: cp.partner_id,
                        },
                      ],
                    };
                  }
                }
              }
              return arr;
            }, {})
          );
        } else {
          const { data } = await rootState.apiService.getInfo();
          billers = data.categories.map(category => {
            return {
              name: category.name,
              value: category.category,
              logoUrl: category.logo_url,
              options: category.subcategories.map(subCategory => {
                return {
                  name: subCategory.name,
                  value: subCategory.subcategory,
                  logoUrl: category.logo_url,
                  parentName: category.name,
                  parentValue: category.category,
                };
              }),
            };
          });
          billers.push({
            name: 'Pajak Lainnya',
            options: [
              {
                name: 'Pajak Lainnya',
                value: 'other',
                logoUrl: '',
                parentValue: 'other',
                parentName: 'Pajak Lainnya',
              },
            ],
          });
        }

        commit('SET_BILLERS', billers);
        return new Promise(resolve => resolve(billers));
      } catch (error) {
        commit('SET_BILLERS', billers);
        return new Promise((_resolve, reject) => reject(error));
      }
    }
    return new Promise(resolve => resolve(state.billers));
  },
};

export default {
  getters,
  actions,
  mutations,
  namespaced: true,
  state: () => ({ ...initialState }),
};
